import React from "react";
import { NavToggle } from "../toggle";
import { CartHeader, CartHeading, CartSubHeader } from "./style";

const CartHead = ({ itemsCount, onCartClose }) => (
  <CartHeader>
    <CartHeading>
      Ihr Warenkorb
      <CartSubHeader>{itemsCount} Artikel</CartSubHeader>
    </CartHeading>
    <NavToggle onClick={onCartClose} isExpanded={true} />
  </CartHeader>
);

export default CartHead;



// WEBPACK FOOTER //
// ../shop_main/components/cart/cartHeader.js